import './Loader.scss';

function Loader() {
  return (
    <div className="loader">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M16.5 9.00037C16.4999 10.5842 15.9984 12.1273 15.0674 13.4086C14.1364 14.6899 12.8237 15.6436 11.3174 16.133C9.81108 16.6224 8.1885 16.6223 6.6822 16.1329C5.17591 15.6434 3.86323 14.6896 2.9323 13.4083C2.00138 12.1269 1.49999 10.5838 1.5 8.99995C1.50001 7.41612 2.00142 5.87296 2.93237 4.59162C3.86331 3.31028 5.176 2.35654 6.6823 1.8671C8.1886 1.37766 9.81119 1.37763 11.3175 1.86703" 
          stroke="#5A5A5A" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
}

export default Loader;
